module.exports = __webpack_public_path__ + "media/american-bittern-2.caa7ee5d.mp3";